var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM9,3.5a1,1,0,1,1-1,1A1,1,0,0,1,9,3.5Zm.881,8.523a4.185,4.185,0,0,1-1.759.477,1.63,1.63,0,0,1-1.112-.349c-.522-.46-.434-1.124-.271-1.8l.492-1.741c.095-.359.287-1.091.018-1.348s-.9-.095-1.262.042l.131-.537A5.135,5.135,0,0,1,7.88,6.286c.855,0,1.48.427,1.48,1.234q0,.113-.026.4a13.4,13.4,0,0,1-.589,2.26,4.391,4.391,0,0,0-.155.882c0,.842.978.634,1.423.424Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/Icon_Info.6b43edb8c737d2d4b23cb87b128de572.svg";
export { ForwardRef as ReactComponent };